import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui, redMui, rydeColors, ScreenDepth } from "@ryde/theme";

export const UserUpdaterRideToggleWrapper = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "user-updated-ride-toggle",
  },
)`
  .user-updater-popper {
    z-index: ${ScreenDepth.FLOATING_MENU};
  }
  .user-updater-border__suspended {
    border-radius: 4px;
    outline: 1px solid ${redMui._700};
    &:hover {
      box-shadow: 2px 2px 5px rgba(255, 0, 0, 0.25);
    }

    svg {
      color: ${redMui._700};
    }
    .user-updater__counter {
      color: ${redMui._300};
    }
    .arrow-button {
      color: ${redMui._300};
    }
  }

  .user-updater-dropdown {
    &:hover {
      background-color: ${rydeColors.focusedOption};
    }

    & .MuiButtonGroup-firstButton {
      padding-inline: 6px;
      min-width: 65px;
      gap: 5px;
    }

    & .MuiButtonGroup-grouped {
      border-color: ${greyMui._300};
      color: ${rydeColors.black};
      gap: 8px;
    }

    .user-updater-group-button.MuiButtonGroup-lastButton.MuiButtonGroup-grouped {
      min-width: 20px;
      padding-inline: 3px;
    }

    .arrow-button {
      padding: 0;
    }
    .user-updater-border__suspended.user-updater-dropdown .arrow-button {
      color: ${redMui._300};
    }
  }

  .user-updated-icon {
    margin-inline-start: -2px;
    font-size: 20px;
    &.grey {
      color: ${greyMui._600};
    }
  }

  .user-icon-replacement {
    width: 22px;
    height: 22px;
  }
`;
